const StyleCompanyUser = {
  printPageArea: {
    laborview: {
      kuuhaku: {
        normal: {
          backgroundColor: '#fff',
          borderTop: '2px solid #fff',
          borderRight: '2px solid #000',
          borderBottom: '2px solid #fff',
          borderLeft: '2px solid #000'
        },
        top: {
          backgroundColor: '#fff',
          borderTop: '2px solid #fff',
          borderBottom: '2px solid #fff',
          borderRight: '2px solid #000',
          borderLeft: '2px solid #000'
        },
        bottom: {
          backgroundColor: '#fff',
          borderTop: '2px solid #fff',
          borderRight: '2px solid #000',
          borderBottom: '2px solid #fff',
          borderLeft: '2px solid #000'
        }
      },
      borderNone: {
        border: 'none'
      },
      titleArea: {
        title1: {
          width: '510px'
        },
        title2: {
          width: '240px'
        },
        title3: {
          width: '110px'
        }
      }
    }
  }
}
export default StyleCompanyUser



// WEBPACK FOOTER //
// ./src/company_user/style/StyleCompanyUser.js